import { defineMessages } from 'react-intl';

export default defineMessages({
    actionLabel: {
        id: 'ml-components-platform-react.FormModalPopover.Save',
        defaultMessage: 'Save'
    },
    cancelLabel: {
        id: 'ml-components-platform-react.FormModalPopover.Cancel',
        defaultMessage: 'Cancel'
    },
    messageActionLabel: {
        id: 'ml-components-platform-react.FormModalPopover.Close',
        defaultMessage: 'Close'
    }
});
